import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeaderNav from './components/HeaderNav';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import BlogPage from './components/BlogPage';
import ScrollToTop from './components/ScrollToTop'; // 1. Ise import karein
import { ToastContainer } from "react-toastify";
import OurFleet from "./components/OurFleet";
import Getquote from "./components/Getquote";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const globalStyles = {
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    backgroundColor: '#ffffff',
    color: '#333333',
    overflowX: 'hidden',
    scrollBehavior: 'smooth'
  };

  return (
    <Router>
      {/* 2. <Router> ke thik neeche ise laga dein */}
      <ScrollToTop /> 

      <div style={globalStyles}>
        <HeaderNav />
        
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/blog/:serviceId" element={<BlogPage />} />
            <Route path="/Our-fleet" element={<OurFleet />} />
                        <Route path="/transport-quote-service" element={<Getquote />} />

          
        </Routes>

        <ToastContainer position="top-right" autoClose={3000} />
        <Footer />
      </div>
    </Router>
  );
}

export default App;